var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"text-decoration-none",attrs:{"to":_vm.to}},[_c('div',{staticClass:"card border-r-01 bs-5 card-container text-center fl-x-cc mu-p"},[_c('p',{staticClass:"m-0 font-poppins-medium text-black c-text text-left",domProps:{"innerHTML":_vm._s(_vm.text)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }